module.exports = __webpack_public_path__ + "media/images/logo-c8eb4717f42a070169babc5bfd6a63e6.png";